import React from "react";
import { useRouter } from "next/router";
import Box from "@mui/material/Box";

import useDialog from "@packages/skillspace/src/common/components/dialog-provider/useDialog";

import JupiterAvatar from "./JupiterAvatar";
import useCourseDetail from "../../context/course-detail/useCourseDetail";
import { FRONTEND_LOGIN_URL } from "../../../common/utils/constants";

const NoAccess: React.FC<{ isAuthenticated: boolean }> = ({
  isAuthenticated,
}) => {
  const { displayDialog } = useDialog();
  const router = useRouter();
  const { courseDetail } = useCourseDetail();

  const handleAssistant = () => {
    const condition = isAuthenticated && !courseDetail?.user_enrolled;
    displayDialog({
      title: condition
        ? "Please enroll in the course to access AI teaching assistant"
        : "Please login to access AI teaching assistant",
      content: "",
      variant: "info",
      agreeText: condition ? "Enroll now" : "Login here",
      disagreeText: "Close",
      onAgree: (closeDialog: any) => {
        closeDialog();
        router.push(
          condition
            ? `/courses/${courseDetail?.slug}`
            : `${FRONTEND_LOGIN_URL}/?next=${router.asPath}`
        );
      },
      onDisagree: (closeDialog: any) => {
        closeDialog();
      },
    });
  };

  return (
    <Box display="flex" justifyContent="flex-end">
      <JupiterAvatar onClick={handleAssistant} />
    </Box>
  );
};

export default NoAccess;
